import styled from 'styled-components'
import above from '@/utils/above'
import getColumnSize from '@/utils/getColumnSize'
import * as UI from '@/components/UI'

export const Section = styled.section`
  margin-top: 1.5rem;
  ${above('sm')`
    margin-top: 2rem;
  `}
  ${above('md')`
    margin-top: 4rem;
    margin-bottom: 5rem;
  `}
  ${above('lg')`
    margin-top: 6.25rem;
  `}
`

export const Grid = styled(UI.Grid)``

export const MainCell = styled.div`
  width: ${getColumnSize(12)};
  ${above('md')`
    width: ${getColumnSize(6)};
  `}
  ${above('lg')`
    width: ${getColumnSize(5)};
    margin-right: ${getColumnSize(1)};
  `}
  ${above('xg')`
    margin-left: ${getColumnSize(1)};
  `}
`

export const Description = styled(UI.SectionDescription)`
  color: ${p => p.theme.colors.gray};
  margin-bottom: 2.5rem;
  ${above('md')`
    color: ${p => p.theme.colors.white};
    opacity: 0.7;
  `}
`

export const Detail = styled.div`
  display: flex;
  align-items: stretch;
  background: ${p => p.theme.colors.white}04;
  padding: 1.5rem;
  border-radius: 0.125rem;
  margin-top: 6rem;
  position: relative;
  & > * {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

export const DetailTitle = styled(UI.BlogText)`
  font-family: ${p => p.theme.type.fonts.headline};
  font-weight: 500;
  max-width: 6.5em;
`

export const DownloadButton = styled(UI.Button)`
  padding: 0.25rem 0.75rem 0.25rem 0.5rem;
  color: ${p => p.theme.colors[p.color]};
  svg {
    margin-right: 0.25rem;
  }
  &:hover,
  &:focus,
  &:active {
    background: ${p => p.theme.colors[p.color]};
    color: ${p => p.theme.colors.white};
    box-shadow: none;
  }
`

export const DetailSpacer = styled.div`
  width: 1px;
  min-height: 6.75rem;
  background: ${p => p.theme.colors.white}10;
  margin: auto 1.5rem;
`

export const DetailLabel = styled(UI.Label)`
  text-transform: uppercase;
  color: ${p => p.theme.colors.gray};
  margin-bottom: 0.25rem;
`

export const DetailText = styled(UI.SmallText)`
  margin-bottom: 1.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`

export const ImageCell = styled.div`
  width: ${getColumnSize(12)};
  position: relative;
  ${above('md')`
    width: ${getColumnSize(6)};
  `}
  ${above('xg')`
    width: ${getColumnSize(5)};
  `}
`

export const ImageWrapper = styled.div`
  margin: 3.5rem -1rem -2rem;
  grid-template-columns: 50% 50%!important;

  ${above('md')`
    position: absolute;
    width: 100%;
    margin: 0 -2rem 0 0;
  `}

  ${above('lg')`
    margin: 0;
    width: 109%;
  `}

  & > * {
    width: 100%;
    height: 100%;

    &:nth-child(n+3) {
      display: none;
    }

    ${above('md')`
      display: block !important;
    `}
`

export const WrapperNewSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const WrapperDetail = styled.div`
  display: flex;
  flex-direction: column;
  background: ${p => p.theme.colors.white}04;
  padding: 20px 24px;
  margin-top: 60px;
  position: relative;
  gap: 20px;
`
